<template>
  <div id="bonds-wrap">
    <h3>Bonds</h3>
    <SimpleList :items="bonds" v-on:change="updateBonds" />
  </div>
</template>

<script>
import SimpleList from '../../util/SimpleList.vue';

export default {
  name: 'CharacterBonds',
  components: { SimpleList },
  data() {
    return {
      newBond: '',
    }
  },
  methods: {
    updateBonds: function() {
      this.$store.commit('updateCharacterProperty', { type: 'bonds', property: this.bonds.map(bond => bond.text) });
    }
  },
  computed: {
    bonds: {
      get() {
        return this.$store.state.character.bonds.map(
          (bond, index) => {
            return { id: index, text: bond }
          });
      }
    }
  }
}
</script>
<style lang="css">
#bonds-wrap {
  width: 70%;
}
</style>